import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Box, Typography } from '@material-ui/core'

import { EventDuration, AbstractEvent } from '@scoir/react-calendar'
import { Title, Section } from '../components/OverlayParts'
import { external } from '../../../visit-colors'

import cn from 'classnames'
import moment from 'moment'
import sanitizeHtml from 'common/sanitize-html-helper'

import MonthEventContainer from '../MonthEventContainer'
import { isShortDuration } from '../durationHelper'

import './PureGenericEvent.scss'
const NO_SUBJECT = 'No Title'

export class GenericEvent extends React.Component {
  createDetails(event) {
    return (
      <Box
        minWidth={200}
        maxWidth={400}
      >
        <Title
          color="common.white"
          bgcolor={external[this.props.linkedCalendarIndex] || '#999'}
        >
          <span>{event.Subject || NO_SUBJECT}</span>
        </Title>
        <Section heading="When">
          <EventDuration event={event} />
        </Section>
        {event.Description && (
          <Section
            maximumHeight={300}
            heading="Description"
          >
            <span
              className="description"
              dangerouslySetInnerHTML={{ __html: sanitizeHtml(event.Description) }}
            ></span>
          </Section>
        )}
      </Box>
    )
  }
  render() {
    return (
      <AbstractEvent
        renderDate={this.props.renderDate}
        event={this.props.event}
        summary={
          <div className={cn('generic-event-comp', this.props.className, `cal-${this.props.linkedCalendarIndex + 1}`)}>
            {this.props.summary}
          </div>
        }
        details={this.createDetails(this.props.event)}
      />
    )
  }
}

const requiredPropTypes = {
  renderDate: PropTypes.object.isRequired,
  event: PropTypes.object.isRequired,
}

GenericEvent.propTypes = {
  ...requiredPropTypes,
  className: PropTypes.string.isRequired,
  summary: PropTypes.element.isRequired,
  linkedCalendarIndex: PropTypes.number.isRequired,
  linkedCalendarName: PropTypes.string,
}

export const WeekView = (props) => {
  return (
    <GenericEvent
      {...props}
      className={cn('week', { 'short-duration': isShortDuration(props.event) })}
      summary={
        <Fragment>
          <Typography variant="srOnly">Calendar: {props.linkedCalendarName}</Typography>
          <strong className="subject">{props.event.Subject || NO_SUBJECT}</strong>
          <br />
          <span
            className="description"
            dangerouslySetInnerHTML={{ __html: sanitizeHtml(props.event.Description) }}
          ></span>
        </Fragment>
      }
    />
  )
}
WeekView.propTypes = requiredPropTypes

export const MonthView = (props) => {
  const startTime = moment(props.event.StartTime)
  const formatTime = startTime.minutes() === 0 ? 'ha' : 'h:mma'
  return (
    <GenericEvent
      {...props}
      className="month"
      summary={
        <MonthEventContainer>
          <Typography variant="srOnly">Calendar: {props.linkedCalendarName}</Typography>
          {!props.event.AllDay && startTime.format(formatTime)} {props.event.Subject || NO_SUBJECT}
        </MonthEventContainer>
      }
    />
  )
}
MonthView.propTypes = requiredPropTypes
